module.exports = __webpack_public_path__ + "static/media/Winzerhof-Pirmann-Logo.23bbbf57.svg";